import { render, staticRenderFns } from "./VideoHd.vue?vue&type=template&id=5d6dc8c4&scoped=true&"
import script from "./VideoHd.vue?vue&type=script&lang=js&"
export * from "./VideoHd.vue?vue&type=script&lang=js&"
import style0 from "./VideoHd.vue?vue&type=style&index=0&id=5d6dc8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6dc8c4",
  null
  
)

export default component.exports